import { axiosWithoutToken } from "../../service";
import { COMMON_UTIL_SERVICE, FILE_MANAGEMENT_SERVICE, QUOTATION_MANAGEMENT_SERVICE, REACT_APP_KSHEMA_POC2, WRAPPER_SERVICE } from "../../urls";

const getMimeType = (extension) => {
  const mimeTypes = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    pdf: 'application/pdf',
    txt: 'text/plain',
    html: 'text/html',
    json: 'application/json',
    csv: 'text/csv',
    mp4: 'video/mp4',
    mp3: 'audio/mpeg',
    zip: 'application/zip',
  };

  return mimeTypes[extension.replace('.', '').toLowerCase()] || 'application/octet-stream';
};

export const getKshemaV2Token = async() => {
  try {
    const response  =  await axiosWithoutToken().get(`${WRAPPER_SERVICE}/token/generate`);
    return response?.data?.access_token
  } catch (error) {
    console.error("Error while generating token". error)
  }

}
export const getFMSToken = async (kshemaV2Token) => {
  const response = await axiosWithoutToken().get(
    `${COMMON_UTIL_SERVICE}/fms/generate/token`,
    {
      headers: {
        Authorization: `Bearer ${kshemaV2Token}`,
      },
    }
  );
  return response?.data?.data?.[0]?.accessToken;
};
const getDocumentURL = async (documentId, fmsToken) => {
  const response = await axiosWithoutToken().get(
    `${FILE_MANAGEMENT_SERVICE}/documents?documentId=${documentId}`,
    {
      headers: {
        Authorization: `Bearer ${fmsToken}`,
      },
    }
  );
  return response?.data?.data;
};
export const getDocumentURLs = async (documentIds = [], fmsToken) => {
  if (documentIds.length) {
    const response = await getDocumentURL(documentIds.join(","), fmsToken)
    return response;
  } else return [];
};

const rawToObjectURL = (rawData, fileExtension) => {
  const mimeType = getMimeType(fileExtension.replace(".", ""));
  const blob = new Blob([rawData], { type: mimeType });
  return URL.createObjectURL(blob);
};

export const getDocument = async (documentDetails, fmsToken, type, source, name) => {
  const response = await axiosWithoutToken().get(`${documentDetails.url}`, {
    headers: {
      Authorization: `Bearer ${fmsToken}`,
    },
    responseType: "arraybuffer",
  });
  return {
    id: documentDetails.fileId,
    name: name || documentDetails.documentName,
    type: type,
    source: source,
    fileType: documentDetails.fileExtension.replace(".", ""),
    docURL: rawToObjectURL(
      response.data,
      getMimeType(documentDetails.fileExtension)
    ),
  };
};

export const getPolicyDocumentIds = async(tranId) => {
  try {
  const response =  await axiosWithoutToken().get(`${WRAPPER_SERVICE}/documents?visibleProposalId=${tranId}`);
  return response?.data?.data
  } catch (error) {
    console.error("Error while getting document details", error)
  }
}

export const getPolicyAndCisDocuments = async(proposalId, kshemaV2Token, fmsToken) => {
    if(proposalId) {
        try {
            const policyDocument = await axiosWithoutToken().post(`${QUOTATION_MANAGEMENT_SERVICE}/policy/document/${proposalId}`,{}, {
                headers: {
                Authorization: `Bearer ${kshemaV2Token}`,
                },
            });
            const cisDocument = await axiosWithoutToken().post(`${QUOTATION_MANAGEMENT_SERVICE}/policy/document/cis/${proposalId}`,null, {
                headers: {
                Authorization: `Bearer ${kshemaV2Token}`,
                },
                responseType: 'blob'
            });
            const cisDocumentBlob = new Blob([cisDocument.data], { type: 'application/pdf' })
            const policyFile = await getDocument({
              id: `policy-doc-${proposalId}`,
                name: "Policy Document",
                type: "Policy",
                source: "internal",
                fileExtension: "pdf",
                url: policyDocument?.data?.data[0]?.policyDocumentUrl
            }, fmsToken, "Policy","internal", "Policy Document ")
            return [
            policyFile,
            {
                id: `cis-${proposalId}`,
                name: "Customer Information Sheet",
                type: "Customer Information Sheet",
                source: "customer",
                fileType: "pdf",
                docURL: URL.createObjectURL(cisDocumentBlob)
            },
          ];
        } catch(error) {
            console.error("Error while fetching CIS document", error)
        }
    } else 
        return []
}

export const fetchKYCDocuments = async(documentIds, fmsToken) => {
    let identityProofDocumentIds = [];
    if(documentIds?.identityProof?.length) {
        documentIds.identityProof.map(identityProofDetails => {
            identityProofDocumentIds = [...identityProofDocumentIds, ... identityProofDetails.documentPath]
        })
    }
    let documentUrlDetails;
    if(identityProofDocumentIds.length) {
        documentUrlDetails = await getDocumentURLs(identityProofDocumentIds, fmsToken)
    }
    // update the document name
    if(documentUrlDetails) {
        documentUrlDetails = documentUrlDetails.map((documentUrlDetail,index) => {
            return {
                ...documentUrlDetail,
                documentName: (documentIds.identityProof.find(identityProof => identityProof.documentPath.includes(documentUrlDetail.folderId))?.documentName  || documentUrlDetail.documentName) +` ${index+1}`
            }
        })
    }

    // get the documents, will return the file(binary file and converted as object url)
    let identityProofFiles = [] 
    if(documentUrlDetails) {
        identityProofFiles= await Promise.all(documentUrlDetails.map(documentDetails => (
            getDocument(documentDetails, fmsToken, "KYC", "kyc")
        )))
    }

    // get the file for address proof
    let addressProofDocumentUrlDetails
    if(documentIds?.addressProof?.documentPath?.length) {
         addressProofDocumentUrlDetails = await getDocumentURLs(documentIds?.addressProof.documentPath, fmsToken)
         // update the document name
        if(addressProofDocumentUrlDetails) {
            addressProofDocumentUrlDetails = addressProofDocumentUrlDetails.map(documentUrlDetail => {
                return {
                    ...documentUrlDetail,
                    documentName: documentIds.addressProof?.documentName || documentUrlDetail.documentName
                }
            })
        }
    }
    let addressProofFiles =[]
    if(addressProofDocumentUrlDetails) {
        addressProofFiles = await Promise.all(addressProofDocumentUrlDetails.map(documentDetails => (
            getDocument(documentDetails, fmsToken, "KYC", "kyc")
        )))
    }
    return  [ ...identityProofFiles, ...addressProofFiles]
    
}

const fetchProposalDocuments = async (documentIds, fmsToken) => {
    let proposalDocumentFiles = [];
    let proposalVideoFiles = []
    let proposalDocumentUrlDetails; 
    let proposalVideoUrlDetails;

    if(documentIds.proposalDocumentId) {
        proposalDocumentUrlDetails = await getDocumentURLs([documentIds.proposalDocumentId], fmsToken)
         //update the document name
         if(proposalDocumentUrlDetails) {
            proposalDocumentUrlDetails = proposalDocumentUrlDetails.map(documentUrlDetail => {
                return {
                    ...documentUrlDetail,
                    documentName: "Proposal Form"
                }
            })
            
            proposalDocumentFiles = await Promise.all(proposalDocumentUrlDetails.map(documentDetails => (
                getDocument(documentDetails, fmsToken, "Proposal Form", "Proposal")
            )))
            
        }
    }
    if(documentIds.videoDeclarationDocumentId) {
        proposalVideoUrlDetails = await getDocumentURLs([documentIds.videoDeclarationDocumentId], fmsToken)
         //update the document name
         if(proposalVideoUrlDetails) {
            proposalVideoUrlDetails = proposalVideoUrlDetails.map(documentUrlDetail => {
                return {
                    ...documentUrlDetail,
                    documentName: "Proposal Video"
                }
            })
            
            proposalVideoFiles = await Promise.all(proposalVideoUrlDetails.map(documentDetails => (
                getDocument(documentDetails, fmsToken, "Proposal", "Proposal")
            )))
            
        }
    }
    return [...proposalDocumentFiles, ...proposalVideoFiles]

}

export const fetchLandDocuments = async (landDocumentIds, fmsToken) => {
    let landDocumentFiles = [];
    let landDocumentUrlDetails; 

    if(landDocumentIds?.length) {
        landDocumentUrlDetails = await getDocumentURLs(landDocumentIds, fmsToken)
         //update the document name
         if(landDocumentUrlDetails) {
            landDocumentUrlDetails = landDocumentUrlDetails.map((documentUrlDetail, index) => {
                return {
                    ...documentUrlDetail,
                    documentName: `Land Document ${index+1}`
                }
            })
            
            landDocumentFiles = await Promise.all(landDocumentUrlDetails.map(documentDetails => (
                getDocument(documentDetails, fmsToken, "Land", "land")
            )))
            
        }
    }
    return landDocumentFiles;
}
export const getHospicashToken = async () => {
  try {
    const response = await axiosWithoutToken().get(`${REACT_APP_KSHEMA_POC2}/token/hospicash-generate`);
    // If response.data is a string, parse it
    const parsedData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    const token = parsedData?.access_token;
    return token;
  } catch (error) {
    console.error("Error fetching Hospicash token:", error);
    return null;
  }
};
export const loadHospiPolicyDocumentsData = async (
  policyDetailCookie,
  setIsLoadingPolicyDocuments,
  setPolicyDocuments
) => {
  if (!policyDetailCookie?.policy_doc_id) return;
  setIsLoadingPolicyDocuments(true);
  const {
    policy_doc_id: policyDocId,
    quotation_doc_id: quotationDocId,
    id_proof: IdProofDocId
  } = policyDetailCookie;
  try {
    const hospiToken = await getHospicashToken();
    if (!hospiToken) {
      console.warn("Hospicash token is undefined");
      setPolicyDocuments([]);
      return;
    }
    // get the policy document
    let policyDocumentDetails
    if(policyDocId) {
      policyDocumentDetails = await getDocumentURLs([policyDocId], hospiToken); 
    }
      //  get the policy document blob
    let policyDocuments = [];
    if(policyDocumentDetails && policyDocumentDetails.length) {
      policyDocuments = await Promise.all(policyDocumentDetails.map(details => (
        getDocument(details, hospiToken, "Policy", "internal", "Policy Document")
      )))
    }


    //get the proposal document // quotation document
    let proposalDocumentDetails
    if(quotationDocId) {
      proposalDocumentDetails = await getDocumentURLs([quotationDocId], hospiToken);
    }
    // get the blob files
    let proposalDocuments = [];
     if(proposalDocumentDetails && proposalDocumentDetails.length) {
      proposalDocuments = await Promise.all(proposalDocumentDetails.map(details => (
        getDocument(details, hospiToken, "Proposal Form", "Proposal", "Proposal Form")
      )))
    }

    // get the document details of id proof
    
    let idProofDocumentDetails
    if(IdProofDocId) {
      idProofDocumentDetails = await getDocumentURLs([IdProofDocId], hospiToken);
    }

    // get the blob files
    let idProofDocuments = [];
     if(idProofDocumentDetails && idProofDocumentDetails.length) {
      idProofDocuments = await Promise.all(idProofDocumentDetails.map((details, index) => (
        getDocument(details, hospiToken, "KYC", "kyc", `ID Proof-${index+1}`)
      )))
    }

    // const results = await getDocumentURLs([policyDocId, quotationDocId], hospiToken);    
    // const fetchedDocs = results.flat().filter(Boolean);
    setPolicyDocuments([...policyDocuments, ...proposalDocuments, ...idProofDocuments]);
  } catch (error) {
    console.error("Error fetching policy documents:", error);
    setPolicyDocuments([]);
  } finally {
    setIsLoadingPolicyDocuments(false);
  }
};




export const loadPolicyDocuments = async(policyDetails, setIsLoadingPolicyDocuments, setPolicyDocuments) => {
    setIsLoadingPolicyDocuments(true);
    // get the document ids
    const documentIds =  await getPolicyDocumentIds(policyDetails.tran_id);
    // set the KYC details
    const kshemaV2Token = await getKshemaV2Token();
    const fmsToken = await getFMSToken(kshemaV2Token)
    const results = await Promise.all([
          getPolicyAndCisDocuments(documentIds.proposalId, kshemaV2Token, fmsToken ),
          fetchProposalDocuments(documentIds, fmsToken),
          // fetchEndorsementDocuments(endorsementNumber),
          fetchKYCDocuments( documentIds, fmsToken),
          fetchLandDocuments(documentIds.landDocuments, fmsToken)
        ]);
    const fetchedDocs = results.flat().filter(Boolean);
    setIsLoadingPolicyDocuments(false)
    setPolicyDocuments(fetchedDocs);
}